import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

// Import hooks
import { useNotifications } from './hooks/useNotifications';
import { useTrackTicket } from './hooks/useTrackTicket';

// Import components
import {
  Header,
  TrackingForm,
  TicketDetails,
  Footer
} from './components';

// Import notification system
import NotificationSystem from '../TroubleshootingForm/components/NotificationSystem';

const TrackTicket = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Initialize hooks
  const {
    showNotification,
    currentNotification,
    addNotification,
    handleNotificationClose
  } = useNotifications();

  const {
    loading,
    ticket,
    formData,
    handleChange,
    handleSubmit,
    handleDownload,
    setPrefilledData
  } = useTrackTicket(addNotification);

  // Handle prefilled tracking ID from notification
  useEffect(() => {
    if (location.state?.prefilledTrackingId) {
      setPrefilledData(location.state.prefilledTrackingId);
      
      // Show notification about prefilled data
      if (location.state?.fromNotification) {
        addNotification('Tracking ID has been filled automatically. Please enter your email to continue.', 'info', 4000);
      }
      
      // Clear the state to prevent it from persisting on refresh
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state, navigate, addNotification, setPrefilledData]);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Header */}
      <Header />

      {/* Main Content */}
      <div className="py-8 flex-1 flex flex-col max-w-4xl mx-auto px-4 sm:px-6 w-full">
        {/* Tracking Form */}
        <TrackingForm
          formData={formData}
          loading={loading}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
        />

        {/* Ticket Details */}
        <TicketDetails
          ticket={ticket}
          loading={loading}
          handleDownload={handleDownload}
        />

        {/* Footer */}
        <Footer ticket={ticket} />
      </div>

      {/* Notification System */}
      <NotificationSystem
        showNotification={showNotification}
        currentNotification={currentNotification}
        handleNotificationClose={handleNotificationClose}
      />
    </div>
  );
};

export default TrackTicket;